/**
 * Sanitize clipboard text before it is sent to the remote-terminal PTY.
 *
 * Pasting into the SC remote shell must insert PLAIN TEXT ONLY — no ANSI/SGR
 * colour, no xterm bracketed-paste wrappers (\x1b[200~ … \x1b[201~), no OSC
 * title sequences, and no stray control bytes. Any of those reaching the PTY
 * corrupt the display (reverse-video highlight, invisible running command).
 *
 * This strips every escape/control construct and keeps only printable text
 * plus tab and newline. Newlines are normalized to CR (\r), which is what the
 * PTY expects for "Enter".
 */
/* eslint-disable no-control-regex -- this sanitiser matches escape/control bytes by design */
export function sanitizeTerminalPaste(s: string): string {
  if (!s) return '';
  return (
    s
      // OSC: ESC ] … terminated by BEL (\x07) or ST (ESC \)
      .replace(/\x1b\][^\x07\x1b]*(?:\x07|\x1b\\)/g, '')
      // CSI (incl. SGR/colour ESC[…m): ESC [ params intermediates final
      .replace(/\x1b\[[0-?]*[ -/]*[@-~]/g, '')
      // 2-byte C1 (ESC + 0x40–0x5F, e.g. ESC \ , ESC P, ESC D …)
      .replace(/\x1b[@-Z\\-_]/g, '')
      // any remaining ESC pair (ESC + one byte)
      .replace(/\x1b./g, '')
      // C0 controls EXCEPT tab (09), LF (0A), CR (0D)
      .replace(/[\x00-\x08\x0b\x0c\x0e-\x1f\x7f]/g, '')
      // C1 controls
      .replace(/[\x80-\x9f]/g, '')
      // normalize CRLF / bare LF to CR (PTY "Enter")
      .replace(/\r\n?/g, '\r')
      .replace(/\n/g, '\r')
  );
}
